import { Box, BoxProps } from '@chakra-ui/react'

export const Divider = (props: BoxProps) => (
  <Box
    w="100%"
    h="1px"
    background="presets.neutral.20"
    _dark={{ background: 'presets.neutral.90' }}
    {...props}
  />
)
